<template>
  <b-navbar-item class="help-menu-item"
  :class="{'dropdown-is-fullwidth': windowWidth < 1024, 'reduce': reduce }">
    <b-dropdown aria-role="list"
                id="dropdown-help-menu"
                :class="{'is-fullwidth': windowWidth < 1024 }"
                position="is-bottom-left"
                :mobile-modal="false"
                >
      <a class="navbar-item"
        slot="trigger"
        slot-scope="{ active }"
        role="button">
        <b-icon pack="far" icon="question-circle"
                class="has-text-link"></b-icon>
        <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
      </a>
      <b-dropdown-item custom>
        <div v-if="manager" class="customer-success-manager-wrapper">
          <p class="csm-title">Customer Success Manager</p>
          <ul class="csm-contacts">
            <li v-if="manager.firstName || manager.lastName" class="csm-contacts-item">
              <b-icon pack="fa" size="is-small" icon="user"></b-icon>
              {{ manager.firstName }} {{ manager.lastName }}
            </li>
            <li v-if="manager.email" class="csm-contacts-item email">
              <b-icon pack="fa" size="is-small" icon="envelope"></b-icon>
              <a :href="`mailto:${manager.email}`">{{ manager.email }}</a>
            </li>
            <li v-if="manager.phone" class="csm-contacts-item phone">
              <b-icon pack="fa" size="is-small" icon="phone" class="fa-rotate-90"></b-icon>
              <a :href="`tel:${manager.phone}`">{{ manager.phoneFormatted }}</a>
            </li>
          </ul>
          <hr class="dropdown-divider">
        </div>
        <div class="support-center-wrapper">
          <p class="support-center-title">Support Center</p>
          <ul class="support-center-contacts">
            <li class="support-center-contacts-item email">
              <b-icon pack="fa" size="is-small" icon="envelope"></b-icon>
              <a href="mailto:support@enhancify.com">support@enhancify.com</a>
            </li>
            <li class="support-center-contacts-item phone">
              <b-icon pack="fa" size="is-small" icon="phone" class="fa-rotate-90"></b-icon>
              <a href="tel:+18132123073">813-212-3073</a>
            </li>
          </ul>
        </div>
      </b-dropdown-item>
    </b-dropdown>
  </b-navbar-item>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'HelpMenu',
  props: {
    reduce: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters('contractor', ['managerCSO', 'paymentStatus', 'plan']),
    ...mapState('partner', {
      managerCSOPartner: (state) => state.leadOwner,
    }),
    manager() {
      const tiers = ['Pro', 'Brand', 'Concierge'];
      const tier = this.plan?.tier ?? null;
      const useContractor = tier && tiers.includes(tier)
          && this.managerCSO
          && this.paymentStatus !== 'Canceled';
      const source = useContractor ? this.managerCSO : this.managerCSOPartner;
      if (!source) return null;
      const phoneRaw = source.additionalContacts?.phones?.[0] ?? '';
      const phoneFormatted = phoneRaw
        ? phoneRaw.replace(/^\+\d/, '').replace(/^(\d{3})(\d{3})(\d+)$/, '$1-$2-$3')
        : '';
      return {
        firstName: source.firstName || '',
        lastName: source.lastName || '',
        email: source.email || '',
        phone: phoneRaw,
        phoneFormatted,
      };
    },

    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },
  watch: {
    reduce() {
      const dropdown = document.getElementById('dropdown-help-menu');
      const dropdownMenu = dropdown.getElementsByClassName('dropdown-menu');
      if (dropdownMenu) {
        if (this.reduce) {
          dropdownMenu[0].classList.add('reduce');
        } else {
          dropdownMenu[0].classList.remove('reduce');
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.navbar-item.help-menu-item
  padding 0
.navbar-item.help-menu-item:hover
  background-color unset
  cursor unset
.csm-title,.support-center-title
  font-weight bold
  white-space nowrap
.csm-contacts,.support-center-contacts
  list-style-type none
  margin-left 10px
  position relative
  >li
    display flex
    margin 10px
    position relative
    &.email,&.phone
      span.icon
        left -24px
    span.icon
      position absolute
      top 2px
      left -20px
      >>> i.fa:before
        color rgb(143,167,179)

.dropdown-trigger .navbar-item
  @media screen and (min-width 1023px)
    border-right 1px solid rgba(222,229,233, 1)
  @media screen and (max-width 1023px)
    padding-right 0
.has-text-link
  font-size 27px
  width 34px
  margin-right .3em
  >>>.fa-question-circle
    color #1c418c
    font-weight 200

#dropdown-help-menu
  cursor default
  >>>.dropdown-item
    font-size 16px
  >>>.dropdown-menu
    transition padding-left .3s linear
    @media screen and (max-width 1023px)
      padding-top 0
      .dropdown-item
        font-size 16px
      padding-left 160px
      &.reduce
        padding-left 135px
    @media screen and (max-width 768px)
      &.reduce
        padding-left 0
</style>
